import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import egLogo from '../../assets/images/eg-logo-blue.svg';
import egWhiteLogo from '../../assets/images/eg-logo.svg';

function EgLogo(props) {
    const { callStatus, isFooter } = props;
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const css = classnames({
        'ulx-header__image': !isFooter,
        'eg-footer__logo': isFooter
    });

    if (isClient && callStatus && (!callStatus.success && !callStatus.fail)) {
        return null;
    }

    const logoImage = isFooter
        ? <a href="https://www.expediagroup.com/"><img className={css} src={egWhiteLogo} alt="Expedia group logo" width="128" height="54" /></a>
        : <a href="https://www.expediagroup.com/"><img className={css} src={egLogo} alt="Expedia group header logo" width="178" height="32" /></a>;

    // paint logo after componentDidMount
    return isClient ? logoImage : '';
}

EgLogo.propTypes = {
    // eslint-disable-next-line react/require-default-props
    callStatus: PropTypes.shape({
        start: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        fail: PropTypes.bool.isRequired
    }).isRequired,
    isFooter: PropTypes.bool
};

EgLogo.defaultProps = {
    isFooter: false
};

export default EgLogo;
